import React from 'react'

const MenuContext = React.createContext({
  setValue: (item: any, path: any[]) => {},
  activePath: [] as any[],
})

export default MenuContext
